module.exports = __webpack_public_path__ + "static/media/cardSlide8.56a86809.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/cardSlide8.wav
// module id = 528
// module chunks = 0